import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import fetchData from '@/util/fetch'

// One meter's detail (/eleena/api/v1/meters/{serial}: energize and the polling server merged). The page, the
// meter section and the chart share it through the query cache, so it is defined once here.
// keepPreviousData: when the serial changes, the previous meter's detail stays (isPreviousData) until the new
// one is loaded; whoever acts on the meter must wait for isPreviousData to clear.
export function useMeterDetail(serialNumber, { keepPreviousData = false } = {}) {
  return useQuery({
    queryKey: computed(() => ['meterDetail', serialNumber.value]),
    queryFn: async () => {
      const result = await fetchData(`/eleena/api/v1/meters/${serialNumber.value}`)
      if (!result || result.status !== 'OK') return null
      return result.data ?? null
    },
    enabled: computed(() => !!serialNumber.value),
    refetchOnWindowFocus: false,
    keepPreviousData,
  })
}
